import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from 'carbon-react/lib/components/button';

interface GetTemplateButtonProps {
  disabled?: boolean;
  onClick?: () => void;
}

export const GetTemplateButton = ({ disabled, onClick }: GetTemplateButtonProps) => {
  return (
    <Button disabled={disabled} onClick={onClick} size="small">
      <FormattedMessage id="predict.get_template" defaultMessage="Get the template" />
    </Button>
  );
};
